<template lang="pug">
  div.filter-panel-wider
    CommonCondition(v-for="(item, i) in filters"
                    :key="i", :filter="item",
                    :addFilterCondition="addFilterCondition",
                    :clearItem="clearItem",
                    :clearAllItems="clearAllItems")
    //- div.more
    //-   button.toggle(type="button", :class="`${showMore ? 'show-less' : 'show-more'}`", @click="toggle")
    //-     span {{showMore ? 'Show Less' : 'Show More'}}
    //-     i.icon.iconfont.icon-down-arrow
    //-   div.more-content(v-if="showMore")
    //-     each i in [1,2,3,4]
    //-       CommonCondition
    //-     ColorCondition
</template>
<script>
import CommonCondition from '@/components/Special/CommonCondition.vue'
import ColorCondition from '@/components/Special/ColorCondition.vue'
export default {
  name: 'FilterPanelWider',
  props: {
    filters: {
      type: Array
    },
    clearItem: {
      type: Function
    },
    clearAllItems: {
      type: Function
    },
    addFilterCondition: {
      type: Function
    }
  },
  data () {
    return {
      showMore: false
    }
  },
  methods: {
    toggle () {
      this.showMore = !this.showMore
    }
  },
  components: {
    CommonCondition,
    ColorCondition
  }
}
</script>
<style lang = "scss" scoped>
.more {
  padding: 1.5rem 0;
  color:#74747b;
  font-size: .875rem;
  border-top: 1px solid #e7e7ef;
}
.more .toggle {
  background: transparent;
  border: none;
  width: 100%;
  text-align: center;
  color:#0080a3;
  &:hover {
    cursor: pointer;
  }
  .icon {
    display: inline-block;
    vertical-align: middle;
    transition: all 0.3s ease;
  }
}

.more .toggle.show-less i{
  transform: rotate(180deg);
}

.more-content {

}
</style>
